import { usePinnedPostsContext } from 'src/context/pinnedPosts'
import { RiPushpinFill, RiArrowRightSLine } from '@remixicon/react'
import i18n from 'src/i18n'
import { usePinPostsSidebar } from 'src/pages/pinPosts/hooks'
import { FeedCard } from '../feedCard'

const PinnedPosts = () => {
  const { highLighted, size } = usePinnedPostsContext()
  const { openPinPostsSidebar, closePinPostsSidebar, isOpenPinPostsSidebar } = usePinPostsSidebar()

  const hasPinnedPosts = Array.isArray(highLighted) && highLighted.length > 0

  const handleOpenPinPosts = () => {
    if (isOpenPinPostsSidebar) {
      return closePinPostsSidebar()
    }

    openPinPostsSidebar()
  }

  if (!hasPinnedPosts) {
    return null
  }

  return (
    <div className="_pt-4 _pb-8">
      <header className="_text-gray-900 _d-flex _align-items-center _justify-content-between _pb-5">
        <div className="_d-flex _align-items-center _justify-content-between">
          <RiPushpinFill size={24} className="_mr-3" />
          <h2 className="_font-18 _font-weight-bold _mb-0">
            {i18n.t('feed.pinnedPosts.header.title')} <span>({size})</span>
          </h2>
        </div>

        <button
          className="_border-0 hot-button _d-flex _p-2 _pl-3 _justify-content-center _align-items-center"
          onClick={handleOpenPinPosts}
        >
          <span>
            {isOpenPinPostsSidebar
              ? i18n.t('pin_post.highlights.buttons.hide_highlights')
              : i18n.t('feed.pinnedPosts.header.see_all')}
          </span>
          <RiArrowRightSLine />
        </button>
      </header>

      {highLighted.map((post) => (
        <FeedCard key={post.id} post={post} highlight />
      ))}
    </div>
  )
}

export default PinnedPosts
